import React from 'react';

type Props = {
    children: React.ReactNode
}

function PageMeta({children}: Props) {
    return (
        <div className="hidden sm:flex sm:flex-row sm:mt-0 sm:flex-wrap sm:space-x-6">
            {children}
        </div>
    );
}

export default PageMeta;